export function getRole(){
    return localStorage.getItem('role');
}